import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static values = { cron: String };

  connect() {
    this.generateSummary();
  }

  cronValueChanged() {
    this.generateSummary();
  }

  generateSummary() {
    const cron = this.cronValue;
    if (!cron || cron.trim() === "") {
      const emptyText = this.element.getAttribute("data-cron-summary-empty-text") || "No schedule.";
      this.updateElement(emptyText);
      return;
    }

    try {
      const [minute, hour, dayOfMonth, month, dayOfWeek] = cron.split(" ");
      let summary = "Runs ";

      if (dayOfWeek !== "*" && dayOfWeek !== "?") {
        const days = {
          0: "Sun",
          1: "Mon",
          2: "Tue",
          3: "Wed",
          4: "Thu",
          5: "Fri",
          6: "Sat",
        };
        const dayNames = dayOfWeek
          .split(",")
          .map((d) => days[d])
          .join(", ");
        summary += `on ${dayNames} `;
      }

      if (dayOfMonth !== "*") {
        summary += `on day(s) ${dayOfMonth} `;
      }

      if (dayOfWeek === "*" && dayOfMonth === "*") {
        summary += "every day ";
      }

      if (hour !== "*") {
        const hours = hour
          .split(",")
          .map((h_str) => {
            const h = parseInt(h_str, 10);
            const ampm = h >= 12 ? "PM" : "AM";
            const formattedHour = h % 12 || 12;
            return `${formattedHour}:00 ${ampm}`;
          })
          .join(", ");
        summary += `at ${hours}.`;
      } else {
        summary += "at all times.";
      }
      this.updateElement(summary);
    } catch (e) {
      this.updateElement("Invalid CRON expression.");
    }
  }

  updateElement(text) {
    this.element.textContent = text;
    this.element.setAttribute("title", text);
  }
}
